const TYPES = {
  SPINNER: {
    SHOW: 'SPINNER/SHOW',
    HIDE: 'SPINNER/HIDE',
    GET: 'SPINNER/GET'
  }
}

export default TYPES
